import React from "react";
import "./AccessLinkPageBlock.scss";

export function AccessLinkPageBlock({ children }) {
  return <div className="access-link-page__block">{children}</div>;
}
